import Dashboard from "./Dashboard.vue";
import CustomerPage from "../customers";
import ClientPage from "../clients";
import InvocesPage from "../invoices";
import ImportPage from "../import";
import UsersPage from '../users'

const dashboardRoutes = [CustomerPage, ClientPage, InvocesPage, ImportPage, UsersPage];
export default {
  path: "/dashboard",
  children: dashboardRoutes,
  component: Dashboard,
  meta: { protected: true }
}
